import { useEffect } from "react";
import { sendGtmEvent } from "./definitions";

export function usePageTracking(name: string): void {
  useEffect(
    function initPageTracking() {
      sendGtmEvent({ event: name });
    },
    [name],
  );
}
